import React from "react";
import PasswordRequirements from "./PasswordRequirements";
import styled from "@emotion/styled";
import { AnimatedDiv, Transition } from "../../AnimatedDiv";

const AnimatedInfoMessage = AnimatedDiv;

type PasswordValidationProps = {
  pwFieldTouched: boolean;
  pwFieldBlurred: boolean;
  password?: string;
};

function PasswordValidationMessage({ password, pwFieldBlurred, pwFieldTouched }: PasswordValidationProps) {
  // Show validation component if input is touched AND
  // always when true
  // when not true, when field blurred and password invalid
  const showValidationMessage = pwFieldTouched;
  // @ts-expect-error Can be `undefined`
  const validationMessage = <PasswordRequirements password={password} highlightRequirements={pwFieldBlurred} />;
  return (
    <Transition>
      <div css={{ marginBottom: 15 }}>
        {showValidationMessage && <AnimatedDiv key="password-info">{validationMessage}</AnimatedDiv>}
      </div>
    </Transition>
  );
}

export default PasswordValidationMessage;
